module.exports = __webpack_public_path__ + "static/media/ah-screen-4.fde08a69.png";